module.exports = __webpack_public_path__ + "img/electric-mining-drill-E-drill-shadow.1aab6c1c.png";